import { AxiosInstance } from "axios";

export const getAllDataAPI = async (api: AxiosInstance, fromDate?: string, toDate?: string) => {
  const params = new URLSearchParams();
  if (fromDate) params.append('fromDate', fromDate);
  if (toDate) params.append('toDate', toDate);
  
  return api.get('/admin/getAllData', { params });
};


export const exportDataAPI = async (api: AxiosInstance, fromDate?: string, toDate?: string) => {
  const params = new URLSearchParams();
  if (fromDate) params.append('fromDate', fromDate);
  if (toDate) params.append('toDate', toDate);
  
  return api.get('/admin/export', { 
    params,
    responseType: 'blob'
  });
};


export const searchDataAPI = async (api: AxiosInstance, searchTerm?: string, fromDate?: string, toDate?: string, quickSearchTerm?: string) => {
  const params = new URLSearchParams();
  if (searchTerm) params.append('searchTerm', searchTerm);
  if (quickSearchTerm) params.append('quickSearchTerm', quickSearchTerm);
  if (fromDate) params.append('fromDate', fromDate);
  if (toDate) params.append('toDate', toDate);
  
  return api.get('/admin/searchData', { params });
};